import {Color} from '~/constants/style';

export const headerContainerStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  mt: 0,
};

export const titleContainerStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
};

export const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: Color.Purple600,
};

export const amountStyle = {
  fontSize: '36px',
  color: Color.PrimaryMain,
  fontWeight: 700,
  mt: 1,
};

export const descriptionStyle = {
  fontSize: '14px',
  color: Color.TextPrimary,
  mt: 0.5,
};

export const monthStyle = {
  color: Color.Purple600,
  fontWeight: 600,
  mt: 1,
};
